import { useSelector } from 'react-redux';
import '../../css/base.css';
import YourStay from '../yourstay/yourStay';
import YourStayCondensed from '../yourstay/yourStayCondensed';

const YourStayContainer = () => {

  const appstate = useSelector((state) => state.appState);

  const returnYourStay = () => {
    if (appstate.formFactor === "MOBILE" || appstate.formFactor === "TABLET") {
      return (<YourStayCondensed />);
    } else {
      return (<YourStay />);
    }
  }

  return (
    <div>
      {returnYourStay()}
    </div>
  );
}

export default YourStayContainer
